import { _ as _slicedToArray } from '../../../../slicedToArray-26803f33.js';
import { _ as _asyncToGenerator, r as regenerator } from '../../../../index-6bb2031f.js';
import { runSession, setUpImage, setUpEffect } from '@pa/pilibs';
import { ADJUST_GRAPH_NAME, WEB_EFFECTS, HSL_GRAPH_NAME } from '../../../../configs/index.js';
import { getLayerManipulations } from '../../../../external/index.js';
import '../../../../unsupportedIterableToArray-577176bf.js';
import '../../../../typeof-92b42de1.js';

function applyAdjust(_x, _x2) {
  return _applyAdjust.apply(this, arguments);
}

function _applyAdjust() {
  _applyAdjust = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(imageData, adjust) {
    var _result;

    var result, _yield$Promise$all, _yield$Promise$all2, adjustEffect, hslEffect, adjustParams, hslParams, isAdjust, isHsl, isOpacity, params, imageEI, _runSession, imageDataBuffer, cleanup, _imageEI, _runSession2, _imageDataBuffer, _cleanup, i;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = new ImageData(new Uint8ClampedArray(imageData.data), imageData.width);

            if (adjust !== null && adjust !== void 0 && adjust.settings.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", result);

          case 3:
            _context.next = 5;
            return Promise.all([setUpEffect(ADJUST_GRAPH_NAME, WEB_EFFECTS), setUpEffect(HSL_GRAPH_NAME)]);

          case 5:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            adjustEffect = _yield$Promise$all2[0];
            hslEffect = _yield$Promise$all2[1];
            adjustParams = adjustEffect.getParams();
            hslParams = hslEffect.getParams();
            isAdjust = ~adjust.settings.findIndex(function (setting) {
              return adjustParams.map(function (item) {
                return item.name;
              }).includes(setting.name);
            });
            isHsl = ~adjust.settings.findIndex(function (setting) {
              return hslParams.map(function (item) {
                return item.name;
              }).includes(setting.name);
            });
            isOpacity = ~adjust.settings.findIndex(function (setting) {
              return setting.name === 'opacity';
            });
            params = adjust.settings.reduce(function (acc, item) {
              acc[item.name] = item.value;
              return acc;
            }, {});

            if (!isAdjust) {
              _context.next = 23;
              break;
            }

            _context.next = 18;
            return setUpImage(result);

          case 18:
            imageEI = _context.sent;
            _runSession = runSession(imageEI, adjustEffect, params), imageDataBuffer = _runSession.result, cleanup = _runSession.cleanup;
            cleanup();
            imageEI.cleanup();
            result = new ImageData(new Uint8ClampedArray(imageDataBuffer), imageData.width);

          case 23:
            if (!isHsl) {
              _context.next = 31;
              break;
            }

            _context.next = 26;
            return setUpImage(result);

          case 26:
            _imageEI = _context.sent;
            _runSession2 = runSession(_imageEI, hslEffect, params), _imageDataBuffer = _runSession2.result, _cleanup = _runSession2.cleanup;

            _cleanup();

            _imageEI.cleanup();

            result = new ImageData(new Uint8ClampedArray(_imageDataBuffer), imageData.width);

          case 31:
            if (isOpacity && (_result = result) !== null && _result !== void 0 && _result.data) {
              for (i = 3; i < (result.height || 1) * (result.width || 1) * 4; i += 4) {
                result.data[i] *= params.opacity / 100;
              }
            }

            try {
              adjustEffect.cleanup();
              hslEffect.cleanup();
            } catch (error) {
              getLayerManipulations().logger(error, 'error');
            }

            return _context.abrupt("return", result);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _applyAdjust.apply(this, arguments);
}

export { applyAdjust as default };
